const locale = {
    en: {
        about_us: 'About Us',
        our_team: 'Our Team',
        career: 'Career',
        faq: 'FAQ',
        tnc: 'Terms and Conditions',
        privacy_policy: 'Privacy Policy',
        cookie_policy: 'Cookie Policy',
        risk_and_warning: 'Risk & Warning',
        contact_us: 'Contact us on',
        registered: 'In Process:',
        socmed: 'Social Media:',
    },
    id: {
        about_us: 'Tentang Kami',
        our_team: 'Tim Kami',
        career: 'Karir',
        faq: 'FAQ',
        tnc: 'Syarat dan Ketentuan',
        privacy_policy: 'Kebijakan Privasi',
        cookie_policy: 'Kebijakan Cookie',
        risk_and_warning: 'Resiko & Peringatan',
        contact_us: 'Hubungi kami di hari',
        registered: 'Proses Izin:',
        socmed: 'Social Media:',
    },
};

export default locale;
